import React from "react";
import { capitalizeFirstCharacter } from "../utils/helper";
import Button from "./Button/Button";

const SubscriptionStatus = ({
  subscription,
  handleSubscribe,
  isAnnual,
  subscriptionPlans,
}) => {
  const getPlanIcon = (planName) => {
    switch (planName?.toLowerCase()) {
      case "growth":
        return (
          <img
            src={`/images/pollBoltIconCyan.svg`}
            alt="Growth Plan"
            className="w-full h-full object-contain"
          />
        );
      case "pro":
        return (
          <img
            src={`/images/pollBoltIconYellow.svg`}
            alt="Pro Plan"
            className="w-full h-full object-contain"
          />
        );
      case "free":
        return (
          <img
            src={`/images/pollBoltIconWhite.svg`}
            alt="Pro Plan"
            className="w-full h-full object-contain"
          />
        );
      default: // Free plan
        return (
          <img
            src={`/images/pollBoltIconCyan.svg`}
            alt="Free Plan"
            className="w-full h-full object-contain"
          />
        );
    }
  };

  const getSubscriptionEndText = () => {
    if (!subscription?.currentPeriodEnd) return null;

    const endDate = new Date(subscription.currentPeriodEnd);
    return `Current period ends on ${endDate.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    })}`;
  };

  const handleUpgrade = () => {
    const currentType = subscription?.plan?.type;
    const targetName = currentType === "free" ? "pro" : "growth";
    const nextPlan = subscriptionPlans.find(
      (plan) => plan?.name?.toLowerCase() === targetName
    );
    if (nextPlan) {
      handleSubscribe(
        nextPlan.id,
        isAnnual
          ? nextPlan.pricingOptions?.annual
          : nextPlan.pricingOptions?.monthly
      );
    }
  };

  const showUpgrade =
    subscription?.plan?.type === "free" ||
    subscription?.plan?.type === "pro";

  return (
    <div className="block md:flex justify-between items-center gap-5">
      <div className="flex items-start md:items-center gap-3.5">
        <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-[#F7F9F8] p-2.5 ring-1 ring-[#EEF0F0]">
          {getPlanIcon(subscription?.plan?.type)}
        </div>
        <div className="flex items-start space-x-4">
          <div className="flex-1">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-[#2A2D31]">
                {capitalizeFirstCharacter(subscription?.plan?.type)} Plan
              </h3>
            </div>
            <p className="text-[#5E6268] text-sm font-medium mt-1">
              You are currently on the{" "}
              {capitalizeFirstCharacter(subscription?.plan?.type)} plan
              {capitalizeFirstCharacter(subscription?.plan?.type) === "Free"
                ? " with basic features"
                : ""}
              .
            </p>
            {subscription?.plan?.type !== "free" && (
              <p className="hidden md:block text-[#8A8F94] text-xs mt-1">
                {getSubscriptionEndText()}
              </p>
            )}
          </div>
        </div>
      </div>

      {showUpgrade && (
        <div className="mt-5 md:mt-0 md:mr-2">
          <Button variant="default" size="md" onClick={handleUpgrade}>
            Upgrade
          </Button>
        </div>
      )}
    </div>
  );
};

export default SubscriptionStatus;
